// Modules
import cn from 'classnames';

// Types
import type { TDropdownDialogueProps } from './Dropdown.type';

// Styles
import styles from './styles.module.scss';

const DropdownDialogue = (props: TDropdownDialogueProps) => {
	const {
		children,
		className,
		...restProps
	} = props;

	const dropdownDialogueCN = cn(styles.legion_dropdown, className);

	return (
		<div className={dropdownDialogueCN} {...restProps}>
			{children}
		</div>
	)
}

export default DropdownDialogue;
